import {
  Button,
  Container,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import HeroSct from "./HeroSct";
import StatsSct from "./StatsSct";
import GymsSct from "./GymsSct";
import CoachesSct from "./CoachesSct";
import BlogSct from "./BlogsSct";
// import MiddleBanners from "./MiddleBanners";
import CollaborateSct from "./CollaborateSct";
import {
  useGetCoachesQuery,
  useGetGymsQuery,
} from "../../../Store/api/queries";
import SEOHelmet from "../../../Components/SeoHelmet";
import SliderSct from "./SliderSct";

export default function Home() {
  const theme = useTheme();
  // gyms
  const { data: gymsData, status: gymsStatus } = useGetGymsQuery();

  // coaches
  const { data: coachesData, status: coachesStatus } = useGetCoachesQuery();

  return (
    <>
      <SEOHelmet
        title="لیست بهترین باشگاه‌های ورزشی | آدین زون"
        description="جستجو و مشاهده لیست برترین باشگاه‌های ورزشی ویژه بانوان و آقایان. امکانات رفاهی، گالری تصاویر، نظرات کاربران و تعرفه‌ها را در آدین زون بررسی کنید."
        keywords="لیست باشگاه های ورزشی, بهترین باشگاه بدنسازی, باشگاه ورزشی بانوان, رزرو باشگاه, ثبت نام باشگاه, باشگاه در مشهد"
        author="AdinZone"
      />
      <Stack sx={{ my: "2rem" }}>
        {/* Hero Section */}
        {/* <HeroSct /> */}
        <SliderSct />
        {/* Stats Section */}
        <StatsSct />
        {/* Gyms Section */}
        <GymsSct gymsStatus={gymsStatus} gymsData={gymsData?.data} />
        {/* Middle Banners */}
        {/* <MiddleBanners /> */}
        {/* Coaches Section */}
        <CoachesSct
          coachesStatus={coachesStatus}
          coachesData={coachesData?.data}
        />
        {/* Middle Banners */}
        <CollaborateSct />
        {/* Blogs */}
        {/* <BlogSct /> */}
      </Stack>
    </>
  );
}
